module.exports = ".full-width {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/modanamnesis/programasfuncionales/programasdisponibles/programasdisponibles.component.scss
// module id = ./src/app/consulta/modanamnesis/programasfuncionales/programasdisponibles/programasdisponibles.component.scss
// module chunks = main